import { isCardNo, isPhoneNumber, validEmail, isPositiveInteger, isValidBankCard, isPrice } from '@/utils/validate'
// import moment from 'moment'
export const validateValidPeriod = (rule, value, callback, form) => {
  if (!form.idcardStartDate) {
    callback(new Error('请输入身份证开始日期'))
  } else if (!form.idcardEndDate) {
    if (form.idcardTermStatus) {
      callback()
    } else {
      callback(new Error('请输入身份证结束日期'))
    }
  } else {
    if (new Date(form.idcardEndDate).getTime() < new Date(value).getTime()) {
      callback('开始日期不能晚于结束日期')
      // } else if (new Date(form.idcardEndDate).getTime() < moment(value).add(10, 'years').valueOf()) {
      //   callback('结束日期必须大于开始日期十年')
    } else {
      callback()
    }
  }
}

export const validateIDCard = (rule, value, callback) => {
  if (isCardNo(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的身份证号码'))
  }
}

export const validatePhoneNumber = (rule, value, callback) => {
  if (isPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的手机号码'))
  }
}
export const validateEmail = (rule, value, callback) => {
  if (validEmail(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的手机号码'))
  }
}
export const validatePositiveInteger = (rule, value, callback) => {
  if (isPositiveInteger(value)) {
    callback()
  } else {
    callback(new Error('请输入数字'))
  }
}

export const validateConfirmPassword = (rule, value, callback, pass) => {
  if (value === '') {
    callback(new Error('请再次输入密码'))
  } else if (value !== pass) {
    callback(new Error('两次输入密码不一致!'))
  } else {
    callback()
  }
}
export const validateBankCard = (rule, value, callback, pass) => {
  if (isValidBankCard(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的银行卡号'))
  }
}

export const validatePrice = (rule, value, callback, pass) => {
  if (!value && value !== 0) {
    callback()
  }
  if (value > 0) {
    if (isPrice(value)) {
      callback()
    } else {
      callback(new Error('价格只能有两位小数'))
    }
  } else {
    callback(new Error('价格不能小于等于0'))
  }
}
